import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

// Used for the partner-scoped router
export const marketingToolingAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.MarketingToolingViewAccess],
  featureToggles: [FeatureToggle.marketingToolingRetailerEnabled],
}
